// extracted by mini-css-extract-plugin
export default {"link":"BookArrays_link__HiLFZ"};